import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import OfflineCheck from './OfflineCheck';
import MasterDocumentEnhancement from './MasterDocumentEnhancement';
import OfflinePackageEnhancement from './OfflinePackageEnhancement';
import { APP_VERSION } from './version';
import './styles.css';
import './mobile-fixes.css';
import './brand-v031.css';
import './master-document.css';
import './hotfix-v033.css';
import './hotfix-v034.css';
import './planning-v035.css';
import './pdf-viewer-v037.css';
import './offline-packs-v037.css';
import './hotfix-v037.css';
import './release-v0312.css';

const offlineCheck = new URLSearchParams(window.location.search).get('offline-check') === '1';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {offlineCheck ? <OfflineCheck /> : <><App /><MasterDocumentEnhancement /><OfflinePackageEnhancement /></>}
  </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  const hadControllerAtStartup = Boolean(navigator.serviceWorker.controller);
  let reloadingForUpdate = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadControllerAtStartup || reloadingForUpdate) return;
    reloadingForUpdate = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`/sw.js?v=${APP_VERSION}`, { updateViaCache: 'none' }).then((registration) => {
      void registration.update();
    }).catch((error) => {
      console.error('Service worker registration failed', error);
    });
  });
}
